module.exports = __webpack_public_path__ + "img/title-2.d43616b3.png";